import {dateTime, duration} from "services/date";
import {VisitActivity} from "../../../types/Visit";
import deserializeBeacon from "./beacon";
import deserializePhysicalObject from "./physical-object";
import deserializeQrCode from "./qr-code";

/**
 * Transform the given visit activity by deserializing object properties
 *
 * @internal
 * @param activity
 */
export default function deserializeVisitActivityEntry(activity: any): VisitActivity {
    activity.duration = duration(activity.duration)
    activity.started_at = dateTime(activity.started_at)
    activity.extended_at = dateTime(activity.extended_at)
    activity.ended_at = dateTime(activity.ended_at)
    activity.created_at = dateTime(activity.created_at)
    activity.updated_at = dateTime(activity.updated_at)

    if (activity.hardware) {
        switch (activity.hardware.type) {
            case 'beacon':
                activity.hardware = deserializeBeacon(activity.hardware)
                break;
            case 'physical-object':
                activity.hardware = deserializePhysicalObject(activity.hardware)
                break;
            case 'qr-code':
                activity.hardware = deserializeQrCode(activity.hardware)
                break;
        }
    }

    activity.trigger_executions = activity.trigger_executions.map((trigger_execution: any) => {
        trigger_execution.created_at = dateTime(trigger_execution.created_at)
        trigger_execution.executed_at = dateTime(trigger_execution.executed_at)
        trigger_execution.updated_at = dateTime(trigger_execution.updated_at)

        // TODO: Deserialize 'trigger_execution.trigger'

        return activity.trigger_executions
    })

    return activity
}